import type { FaireProductEntity } from "../../entity_types/product";

export const p_82qrep74m4: FaireProductEntity = {
  token: "p_82qrep74m4",
  type: "product",
  name: "fall leaves paintable watercolor notecard set",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/5f85b0e0bc5a0906b5794eb12d0b577956d41fa0f52c8f639dd3c57cf1de5d46.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/778b57bf58fea5b52af2a619b510d780a058ff3b820cc8511dea83aaf1588b94.jpeg",
    "https://cdn.faire.com/fastly/8ee685fe5c5fc85818021d53e469584747e38798ddcdd093ea65e83215b31111.jpeg",
    "https://cdn.faire.com/fastly/cf0caf27e5d583587dc7e49a261b3fee68fa904382baa12617cf301784a4ac1e.jpeg",
    "https://cdn.faire.com/fastly/9ef1a3284e2eb2306187f101ff8321ec149c7da3db657544fa752044e457b076.jpeg",
    "https://cdn.faire.com/fastly/f5f80cbf52237679ff2e54bf1658e5b4157145afadf1386b18ebd7dbfb0ba9ad.jpeg",
    "https://cdn.faire.com/fastly/05ada5dd33fe28162b8bd28d4351655f0d2b51a3c13fa02a37ce66a380d58cf8.jpeg",
    "https://cdn.faire.com/fastly/0143b692b23561108e0735d21a057e4757a723687df2e4363d9ccda46e21e7ee.jpeg",
    "https://cdn.faire.com/fastly/04d74ef3cdcf705daf38e209cc4cb9367a6567e673aea75d5d7361dcec96db86.jpeg",
    "https://cdn.faire.com/fastly/f52bbcabd90185641eab4176d9759beff5971f6a3a64a009d25de45ab470b037.jpeg",
    "https://cdn.faire.com/fastly/6e05fb4d19fc95ea8beb6d863476c3c0f6675bc819b61ba55703c79f3672c5c3.jpeg",
  ],
  priceDollars: 9,
  description:
    "A seasonal style that moves well from late summer through Thanksgiving. Customers paint the cards themselves and send them — no experience necessary, simple instructions included.\n\nIllustrations: maple, maple stem, oak, aspen.\n\n$9 wholesale · $18 retail · set of eight notecards + envelopes\n",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:11:13.737Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
